// extracted by mini-css-extract-plugin
module.exports = {"MorePosts__posts":"gh_a pz_mz pz_mu pz_sz"};